import type { ProductAttributeSelectorProps } from '../config.types';
import React from 'react';
import { useGetAttributeDataForSelector } from './hooks/getAttributeDataForSelector';
import { getFoilConfigs } from '../utils/mappings/useDeriveFoilIds';
import { ChoiceGroup, useCustomizationContext } from '@apps/card/routes/CardCustomizer';
import { Flex, Box } from '@withjoy/joykit';
import { useMinorUnitsToPriceString } from '@apps/card/hooks/useMinorUnitsToPriceString';
import { useTranslation } from '@shared/core';

export const FoilChoiceAttribute = (props: ProductAttributeSelectorProps) => {
  const { product, attributeId, priceCalculator } = props;
  const data = useGetAttributeDataForSelector(props);
  const [cardQuantity] = useCustomizationContext(draft => draft.config.customizations.quantity);
  const formatPrice = useMinorUnitsToPriceString();
  const { tq } = useTranslation('stationery');

  if (!data || !data.options.selected) {
    return null;
  }

  //   const uiConfig = data.attribute.attributeUIConfig;
  //   const options = data.options.uiConfigurations;
  const state = data.state;
  const selectedOptionId = data.options.selected.optionId;
  const selectedOptionPrice = priceCalculator.getOptionPrice(product.id, { attributeId, optionId: selectedOptionId }, cardQuantity);
  const formattedOptionPrice = formatPrice(selectedOptionPrice, { canShowFreeLabel: true });

  const foilConfigs = getFoilConfigs(product, attributeId);

  if (!foilConfigs) {
    return null;
  }
  const selectedFoil = foilConfigs.find(f => f.optionId === selectedOptionId);

  const getName = (optionId: string) => {
    const option = data.options.uiConfigurations.find(o => o.optionId === optionId);
    return option?.title ?? '';
  };

  return (
    <ChoiceGroup
      value={selectedFoil!.optionId}
      getName={getName}
      title={tq`Foil`}
      price={selectedOptionPrice !== 0 ? `+ ${formattedOptionPrice}` : formattedOptionPrice}
    >
      <Flex gap={3}>
        {foilConfigs.map(foilOffer => {
          const isSelected = foilOffer.optionId === selectedOptionId;

          return (
            <Flex
              borderRadius={44}
              justifyContent="center"
              alignItems="center"
              position="relative"
              width={44}
              height={44}
              key={foilOffer.colorId}
              as="button"
              backgroundColor={isSelected ? 'mono14' : 'mono2'}
              //   onClick={() => onSelect(foilOffer.colorId)}
              onClick={() => {
                state.setOptionId(foilOffer.optionId);
              }}
            >
              <Box
                position="absolute"
                width={38}
                height={38}
                borderRadius={38}
                backgroundImage={`url(${foilOffer.assetThumbnailUrl})`}
                backgroundSize="cover"
                backgroundPosition="center"
                outline={isSelected ? '1px solid white' : '2px solid white'}
              />
            </Flex>
          );
        })}
      </Flex>
    </ChoiceGroup>
  );
};
